'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.getCache = getCache;
exports.setCache = setCache;
exports.resetCache = resetCache;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// keep track of what path has been mounted, what is in redux, which saga has been started, etc

var cache = {};

function getCache(path, variable) {
  var joinedPath = Array.isArray(path) ? path.join('.') : path;

  var cachePart = cache[joinedPath] || {};

  if (variable) {
    return cachePart[variable];
  } else {
    return cachePart;
  }
}

function setCache(path, object) {
  var joinedPath = Array.isArray(path) ? path.join('.') : path;
  cache[joinedPath] = (0, _assign2.default)(cache[joinedPath] || {}, object);

  return cache[joinedPath];
}

function resetCache() {
  cache = {};
}


//////////////////
// WEBPACK FOOTER
// ./~/kea/es/kea/cache/index.js
// module id = 330
// module chunks = 2